import {
	chain,
	zipObject
} from 'lodash';

import Http from '@/support/http';

export default {
	state: {
		list: [],
		selected: {}
	},
	getters: {
		themes: (state) => state.list,
		currentTheme: (state) => state.selected
	},
	mutations: {
		SET_THEME_LIST(state, payload) {
			state.list = payload;
		},
		SET_THEME(state, payload) {
			state.selected = payload;
		}
	},
	actions: {
		getSchoolThemes(context, payload) {

			if (payload && payload.id) {

				return Http.get(`v1/school-theme/user/${ payload.id }`).then((response) => {

					const data = chain(response.data).groupBy('level').toPairs().map((current) => {

						let zip = zipObject([
							'gradeLevel',
							'list'
						], current);

						zip.gradeName = this.getters.ENUM['SchoolClassLevelType'][zip.gradeLevel];

						return zip;

					}).value();

					context.commit('SET_THEME_LIST', data);

					return response;

				});

			}
		},
		setTheme(context, payload) {
			context.commit('SET_THEME', payload);
		}
	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/theme/store.js